import { render, staticRenderFns } from "./crm-orders-by-phone.vue?vue&type=template&id=6f508728&scoped=true&"
import script from "./crm-orders-by-phone.vue?vue&type=script&lang=js&"
export * from "./crm-orders-by-phone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f508728",
  null
  
)

export default component.exports